<template>
    <div class="container">
        <div class="detail_box">
            <div class="header">
                <span class="title">销售单</span>
                <el-link class="back_btn" type="danger" :underline="false">返回销售列表</el-link>
            </div>
            <el-form :model="form" size="mini" :inline="true" class="detail_form" >
                <div class="flex">
                    <el-form-item label="客户名称：" label-width="70px">
                        <el-select class="input_box" v-model="form.param" placeholder="" size="mini">
                            <el-option value="1">123</el-option>
                            <el-option value="2">123</el-option>
                            <el-option value="3">123</el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="付款方式：" label-width="110px">
                        <el-select class="input_box" v-model="form.param" placeholder="" size="mini">
                            <el-option value="1">123</el-option>
                            <el-option value="2">123</el-option>
                            <el-option value="3">123</el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="销售日期：" label-width="70px">
                        <el-date-picker class="input_box" v-model="form.param" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="发货日期：" label-width="auto">
                        <el-date-picker class="input_box" v-model="form.param" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                </div>
                <div class="flex">
                    <el-form-item label="销售人：" label-width="70px">
                        <el-input class="input_box" v-model="form.param" placeholder="" size="mini"></el-input>
                    </el-form-item>
                    <el-form-item label="预计收汇日期：" label-width="110px">
                        <el-date-picker class="input_box" v-model="form.param" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="REC：" label-width="70px">
                        <el-input class="input_box" v-model="form.param" placeholder="" size="mini"></el-input>
                    </el-form-item>
                </div>
                <div class="text-right pr-10">
                    <i class="settings-icon"></i>
                </div>
                <div class="table_path">
                    <el-table :data="list" style="width: 100%" border height="100%" size="mini" header-cell-class-name="list_table_th">
                        <el-table-column type="index"></el-table-column>
                        <el-table-column label="操作"></el-table-column>
                        <el-table-column label="捆包号"></el-table-column>
                        <el-table-column label="品牌"></el-table-column>
                        <el-table-column label="品名"></el-table-column>
                        <el-table-column label="等级"></el-table-column>
                        <el-table-column label="厚度"></el-table-column>
                        <el-table-column label="长度"></el-table-column>
                        <el-table-column label="总宽度"></el-table-column>
                        <el-table-column label="立方"></el-table-column>
                        <el-table-column label="单价">
                            <template slot="header">
                                <span>单价</span>
                                <el-link type="danger" :underline="false">(批量)</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column label="金额（￥）"></el-table-column>
                    </el-table>
                </div>
                <div class="remark">
                    <span>备注：</span>
                    <div class="text">
                    </div>
                </div>
                <div class="order_other">
                    <div class="label_no_padding_form">
                        <el-form-item label="打款方式：" label-width="70px">
                            <el-select class="edit_select" v-model="form.param" placeholder="" size="mini">
                                <el-option value="1">123</el-option>
                                <el-option value="2">123</el-option>
                                <el-option value="3">123</el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="账号：" label-width="70px"></el-form-item>
                        <el-form-item label="户名：" label-width="70px"></el-form-item>
                        <el-form-item label="开户行：" label-width="70px"></el-form-item>
                    </div>
                    <div class="label_no_padding_form bottom_flex">
                        <el-form-item label="首次付款￥：">
                            <el-input class="edit_input" v-model="form.param" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="优惠￥：">
                            <el-input class="edit_input" v-model="form.param" placeholder=""></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="footer">
                    <el-form-item label="税率(%)：">
                        <el-input class="input_box" v-model="form.param" placeholder=""></el-input>
                    </el-form-item>
                    <div class="">
                        <el-button size="mini" plain @click="dialogVisible = true">选择商品</el-button>
                        <el-button size="customize" plain>取消</el-button>
                        <el-button size="customize" plain>保存</el-button>
                        <!-- <el-button size="customize" plain>保存并新增</el-button> -->
                        <el-button size="customize" type="danger">保存并提交</el-button>
                    </div>
                </div>
            </el-form>
        </div>

        <el-dialog v-dialog-drag title="选择商品" :visible.sync="dialogVisible" width="1224px">
            <div class="dialog_box">
                <hr class="dialog_hr">
                <div class="filter_path">
                    <el-form :inline="true" :model="params" class="form-inline">
                        <el-form-item>
                            <el-select class="filter_input" v-model="params.belong" placeholder="供应商" size="mini">
                                <el-option value="1">123</el-option>
                                <el-option value="2">123</el-option>
                                <el-option value="3">123</el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-select class="filter_input" v-model="params.belong" placeholder="品牌" size="mini">
                                <el-option value="1">123</el-option>
                                <el-option value="2">123</el-option>
                                <el-option value="3">123</el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-select class="filter_input" v-model="params.belong" placeholder="品名" size="mini">
                                <el-option value="1">123</el-option>
                                <el-option value="2">123</el-option>
                                <el-option value="3">123</el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-select class="filter_input" v-model="params.belong" placeholder="等级" size="mini">
                                <el-option value="1">123</el-option>
                                <el-option value="2">123</el-option>
                                <el-option value="3">123</el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-input class="filter_input" v-model="params.project" placeholder="厚度" size="mini"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input class="filter_input" v-model="params.project" placeholder="长度" size="mini"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-select class="filter_input" v-model="params.belong" placeholder="仓库" size="mini">
                                <el-option value="1">123</el-option>
                                <el-option value="2">123</el-option>
                                <el-option value="3">123</el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-link type="danger" :underline="false">重置</el-link>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="danger" size="mini">查询</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table_path">
                    <el-table :data="list" style="width: 100%" border height="500px" size="mini" header-cell-class-name="list_table_th">
                        <el-table-column type="selection"></el-table-column>
                        <el-table-column label="捆包号"></el-table-column>
                        <el-table-column label="供应商"></el-table-column>
                        <el-table-column label="品牌"></el-table-column>
                        <el-table-column label="品名"></el-table-column>
                        <el-table-column label="等级"></el-table-column>
                        <el-table-column label="厚度"></el-table-column>
                        <el-table-column label="长度"></el-table-column>
                        <el-table-column label="片数"></el-table-column>
                        <el-table-column label="总宽度"></el-table-column>
                        <el-table-column label="立方"></el-table-column>
                        <el-table-column label="销售价"></el-table-column>
                        <el-table-column label="仓库"></el-table-column>
                        <el-table-column label="入库时间"></el-table-column>
                        <el-table-column label="库龄"></el-table-column>
                        <el-table-column label="备注"></el-table-column>
                    </el-table>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <div class="">
                    <span>选中件数：10件</span>
                    <span>选中方数：3.6555</span>
                </div>
                <div class="">
                    <el-button size="mini" plain @click="dialogVisible = false">取消</el-button>
                    <el-button size="mini" plain @click="dialogVisible = false">选中</el-button>
                    <el-button size="mini" type="danger" @click="dialogVisible = false">选中并退出</el-button>
                </div>
            </div>
        </el-dialog>

    </div>
</template>
<style scoped lang="scss">
    .container{
        padding: 15px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2;
        .detail_box{
            width: 920px; height: 100%; padding: 25px 35px 35px; overflow: auto; box-shadow:0px 0px 10px rgba(0,0,0,0.16); border-radius:3px; position: relative; display: flex; flex-direction: column; align-items: stretch; text-align: left;
            .header{
                display: flex; align-items: center; justify-content: center; position: relative; margin-bottom: 30px;
                .title{ font-size:24px; font-weight:bold; color: #333333; }
                .back_btn{ position: absolute; right: 0; }
            }
            .detail_form{
                display: flex; flex-direction: column; flex: 1;
                .flex{
                    display: flex;
                    & > div{ margin-right: 10px; }
                }
                .input_box{ width: 120px; }
            }
            .table_path{ flex: 1;}
            .remark{
                border: 1px solid #CFCFCF; display: flex; align-items: center; justify-content: flex-start; font-size: 14px; color: #333333; padding: 5px;
                .text{ flex: 1; height: 58px; display: flex; flex-direction: column; justify-content: center; }
            }
            .order_other{
                display: flex; align-items: stretch; border: 1px solid #CFCFCF; border-left: 0px none;
                & > div{ flex: 1; border-left: 1px solid #CFCFCF; }
                & > div:first-child{ padding: 11px 0 9px 50px; }
                .label_no_padding_form{
                    .edit_select{ width: 151px; }
                    .edit_input{ width: 118px; }
                    & > div{ margin-bottom: 4px; display: block; }
                }
                .bottom_flex{ display: flex; align-items: flex-end; padding-right: 12px; padding-bottom: 8px; width: 423px; flex: none; padding-left: 12px; }
            }
            .footer{
                display: flex; align-items: center; justify-content: space-between; margin-top: 50px;
                & > div{ margin: 0; }
            }
        }
        .dialog_box{
            .filter_path{
                padding: 15px; background-color: #F4F5F9; margin-bottom: 24px;
                .filter_input{
                    width: 120px;
                    & + .filter_input{ margin-left: 34px; }
                }
            }
        }
        .dialog-footer{
            display: flex; justify-content: space-between; align-items: center; font-size:12px; color: #000000; font-weight:bold;
            div:first-child > span + span{ margin-left: 80px; }
        }
    }
</style>
<script>
    export default {
        components:{
        },
        data(){
            return{
                tab : 1,

                last_page: 10,
                current_page: 1,
                total: 1000,
                list : [],
                form:{
                    param : ""
                },
                // dialog START
                dialogVisible : false,
                params:{
                    keyword: "",
                    belong: "",
                    project: "",
                    per_page: 20
                },
                // dialog END

            }
        },
        methods:{
            getPage(obj){
                this.current_page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
        },
    }
</script>
